<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
      }"
      height="128"
      card
      color="#fff"
    >
      <v-layout row wrap align-center>
        <v-flex xs12>
          <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:item="props">
              <router-link
                :to="props.item.href"
                :is="props.item.disabled ? 'span' : 'router-link'"
              >
                {{ props.item.text }}
              </router-link>
            </template>
            <template v-slot:divider>
              <v-icon>chevron_right</v-icon>
            </template>
          </v-breadcrumbs>
        </v-flex>
        <v-flex xs12>
          <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-block',
              backgroundColor: '#ef565c',
              borderRadius: '0.5rem',
            }"
          >
            <v-icon medium color="#fff">add</v-icon>
          </div>
          <h1 style="display: inline">Nuevo Colegio</h1>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <div class="schedule-container">
      <v-container fluid grid-list-xl>
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-card flat class="border-container">
              <v-card-text>
                <strong>¿QUE TIPO DE LICENCIA ES?</strong>
                <v-radio-group v-model="filters.type" hide-details>
                  <v-radio
                    color="red"
                    value="CLIENTE"
                    :class="[
                      filters.type == 'CLIENTE' ? 'radio-selected' : '',
                      'radio-border',
                      'radio-up',
                    ]"
                  >
                    <template v-slot:label>
                      <div>
                        <strong
                          :class="[
                            filters.type == 'CLIENTE' ? 'red--text' : '',
                          ]"
                        >
                          Cliente
                        </strong>
                        <div>
                          Pueden acceder a la plataforma una vez que los des de
                          alta y solo se suspenderá el servicio cuando tu lo
                          indiques.
                        </div>
                      </div>
                    </template>
                  </v-radio>
                  <v-radio
                    color="red"
                    value="TRIAL"
                    :class="[
                      filters.type == 'TRIAL' ? 'radio-selected' : '',
                      'radio-border',
                      'radio-down',
                    ]"
                  >
                    <template v-slot:label>
                      <div>
                        <strong
                          :class="[filters.type == 'TRIAL' ? 'red--text' : '']"
                        >
                          Trial
                        </strong>
                        <div>
                          Pueden acceder a la plataforma solo el periodo de
                          prueba indicado, una vez cumplido el periodo se
                          suspende el servicio automáticamente.
                        </div>
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>

                <div class="mt-3">
                  <strong>{{
                    filters.type == 'CLIENTE'
                      ? 'ESCRIBE EL NÚMERO DE LICENCIAS'
                      : 'SELLECCIONA EL PERIODO DE PRUEBA'
                  }}</strong>
                  <v-text-field
                    class="border-container mt-3"
                    hide-details
                    solo
                    flat
                    dense
                    v-if="filters.type == 'CLIENTE'"
                    required
                    type="number"
                    v-model="$v.formCollege.numberLicences.$model"
                  />

                  <div v-else class="radio--container mt-3">
                    <v-radio-group
                      v-model="selectedDay.day"
                      row
                      style="justify-content: center; padding: 5px 0; margin: 0"
                      hide-details
                    >
                      <v-radio
                        label="7 días"
                        value="1675101600000"
                        color="red"
                      ></v-radio>
                      <v-radio
                        label="15 días"
                        value="1675102600000"
                        color="red"
                      ></v-radio>
                      <v-radio
                        label="30 días"
                        value="1675103600000"
                        color="red"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                  <span
                    class="error-pass"
                    v-if="
                      submitted &&
                      !$v.formCollege.numberLicences.required &&
                      filters.type == 'CLIENTE'
                    "
                    >Introduzca el número de licencias</span
                  >
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md8>
            <!-- <FormCreateCollege/> -->
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-card flat class="border-container">
                  <v-card-text>
                    <strong>INFORMACIÓN DEL COLEGIO</strong>
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <span>Nombre del colegio</span>
                        <v-text-field
                          class="border-container"
                          hide-details
                          solo
                          flat
                          rounded
                          required
                          v-model="$v.formCollege.nameCollege.$model"
                        />

                        <span
                          class="error-pass"
                          v-if="
                            submitted && !$v.formCollege.nameCollege.required
                          "
                          >Nombre del colegio es obligatorio</span
                        >
                      </v-flex>
                      <v-flex xs12 sm6>
                        <span>ID_Cliente (opcional)</span>
                        <v-text-field
                          class="border-container"
                          hide-details
                          solo
                          flat
                          rounde
                          v-model="id_cliente"
                        />
                      </v-flex>
                    </v-layout>
                    <div class="mt-3">
                      <strong>INFORMACIÓN DEL ADMINISTRADOR DEL COLEGIO</strong>
                      <v-layout row wrap>
                        <v-flex xs12 sm6>
                          <span>Nombre del Administrador</span>
                          <v-text-field
                            class="border-container"
                            hide-details
                            solo
                            required
                            flat
                            dense
                            v-model="$v.formCollege.nameAdmin.$model"
                          />

                          <span
                            class="error-pass"
                            v-if="
                              submitted && !$v.formCollege.nameAdmin.required
                            "
                            >Nombre del administrador es obligatorio</span
                          >
                        </v-flex>
                        <v-flex xs12 sm6>
                          <span>Apellido del Administrador</span>

                          <v-text-field
                            class="border-container"
                            hide-details
                            solo
                            required
                            flat
                            dense
                            v-model="$v.formCollege.lastNameAdmin.$model"
                          />

                          <span
                            class="error-pass"
                            v-if="
                              submitted &&
                              !$v.formCollege.lastNameAdmin.required
                            "
                            >Apellido del Administrador es obligatorio</span
                          >
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12 sm6>
                          <span>Correo electrónico del Administrador</span>
                          <v-text-field
                            class="border-container"
                            hide-details
                            solo
                            flat
                            required
                            dense
                            v-model="$v.formCollege.emailAdmin.$model"
                          />
                          <div
                            v-if="submitted && $v.formCollege.emailAdmin.$error"
                            class="error-pass"
                          >
                            <span v-if="!$v.formCollege.emailAdmin.required"
                              >Correo electrónico del Administrador es
                              obligatorio</span
                            >
                            <span v-if="!$v.formCollege.emailAdmin.email"
                              >Ingrese un correo electronico valido</span
                            >
                          </div>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <div>
                            <span class="ml-2 mt-2"
                              >Dirección del colegio (opcional)</span
                            >
                            <v-text-field
                              class="border-container"
                              hide-details
                              solo
                              flat
                              required
                              dense
                              v-model="$v.formCollege.address.$model"
                            />
                          </div>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12 sm6>
                          <span>Contraseña</span>
                          <v-text-field
                            class="border-container"
                            hide-details
                            solo
                            flat
                            dense
                            required
                            v-model="$v.formCollege.passwordAdmin.$model"
                          />

                          <div
                            v-if="
                              submitted && $v.formCollege.passwordAdmin.$error
                            "
                            class="error-pass"
                          >
                            <span v-if="!$v.formCollege.passwordAdmin.required"
                              >La contraseña es obligatoria</span
                            >
                          </div>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <span>Confirmar contraseña</span>

                          <v-text-field
                            class="border-container"
                            hide-details
                            solo
                            flat
                            required
                            dense
                            v-model="$v.formCollege.confirmPassword.$model"
                          />
                          <div
                            v-if="
                              submitted && $v.formCollege.confirmPassword.$error
                            "
                            class="error-pass"
                          >
                            <span
                              v-if="!$v.formCollege.confirmPassword.required"
                              >La contraseña es obligatoria</span
                            >
                            <span
                              v-else-if="
                                !$v.formCollege.confirmPassword.sameAsPassword
                              "
                              >Las contraseñas deben de coincidir</span
                            >
                          </div>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>

                  <div class="container--btn mt-2 mb-2">
                    <v-spacer></v-spacer>
                    <v-btn
                      class="custom-border"
                      @click="cancel()"
                      depressed
                      outline
                      >Cancelar</v-btn
                    >
                    <v-btn
                      class="custom-border"
                      @click="submit()"
                      depressed
                      outline
                      >Guardar
                    </v-btn>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <Success
            v-model="success.modal"
            description="!Colegio creado con éxito!"
          />
          <Cancel
            :value="CancelCollege.modal"
            title="¿Estas seguro que deseas cancelar la creación del colegio?"
            description="Toda la información ingresada, se perderá"
            v-on:desition="cancelCollegeEvt"
          />
          <error v-model="error.modal" :text="error.text" />
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import { email, required, sameAs } from 'vuelidate/lib/validators'
import Cancel from '../components/CancelCollege.vue'
import Success from '../components/SuccessSa.vue'

// import FormCreateCollege from "./FormCreateCollege.vue"
import loading from '../../../../Dialogs/Loading.vue'
// import success from "../../Dialogs/Success.vue";
import error from '../../../../Dialogs/Error.vue'

export default {
  validations: {
    formCollege: {
      nameCollege: { required },
      nameAdmin: { required },
      lastNameAdmin: { required },
      emailAdmin: { required, email },
      passwordAdmin: { required },
      confirmPassword: { required, sameAsPassword: sameAs('passwordAdmin') },
      numberLicences: { required },
      address: {},
    },
  },
  components: {
    // FormCreateCollege,
    loading,
    // success,
    Success,
    error,
    Cancel,
  },
  data: () => ({
    CancelCollege: {
      modal: false,
    },
    success: {
      modal: false,
    },
    error: {
      modal: false,
      text: '',
    },
    submitted: false,
    formCollege: {
      nameCollege: '',
      nameAdmin: '',
      lastNameAdmin: '',
      emailAdmin: '',
      passwordAdmin: '',
      confirmPassword: '',
      numberLicences: null,
      address: '',
    },
    id_cliente: '',
    numberLicences: null,
    filters: { type: 'CLIENTE' },
    selectedDay: { day: '1675101600000' },
    breadcrumbs: [
      {
        text: 'Colegios',
        disabled: false,
        href: '/es/sa/panel/colleges',
      },
      {
        text: 'Nuevo Colegio',
        disabled: true,
        href: '/es/sa/panel/college/create',
      },
    ],
  }),
  methods: {
    successCreate() {
      setTimeout(() => {
        this.$router.push({
          name: 'Colleges',
        })
      }, 5000)
    },
    submit() {
      let body1
      switch (this.filters.type) {
        case 'CLIENTE':
          body1 = {
            name: this.formCollege.nameCollege,
            type: 1,
            licenses: this.formCollege.numberLicences,
            idCustomer: this.id_cliente,
            address: this.formCollege.address,
            administrator: {
              firstName: this.formCollege.nameAdmin,
              lastName: this.formCollege.lastNameAdmin,
              email: this.formCollege.emailAdmin,
              password: this.formCollege.passwordAdmin,
            },
          }
          break
        case 'TRIAL':
          this.formCollege.numberLicences = 0
          body1 = {
            name: this.formCollege.nameCollege,
            type: 2,
            trialExpiration: 1675101600000,
            idCustomer: this.id_cliente,
            address: this.formCollege.address,
            administrator: {
              firstName: this.formCollege.nameAdmin,
              lastName: this.formCollege.lastNameAdmin,
              email: this.formCollege.emailAdmin,
              password: this.formCollege.passwordAdmin,
            },
          }
        default:
          break
      }
      this.submitted = true
      this.$v.formCollege.$touch()
      if (this.$v.formCollege.$invalid) {
        return
      }
      this.$store
        .dispatch('colleges/createCollege', body1)
        .then((res) => {
          this.success.modal = true
          setTimeout(() => {
            this.success.modal = false
            this.$router.push({
              name: 'Colleges',
            })
          }, 2000)
        })
        .catch((e) => {
          console.log(e)
          this.processErrors(e)
        })
        .finally((f) => console.log(f, 'finish'))
    },
    processErrors(error) {
      switch (error.response.status) {
        case 400:
          this.error.modal = true
          this.error.text =
            'EL correo que intenta registrar ya esta siendo utilizado'
          break
      }
    },
    cancel() {
      if (
        !this.formCollege.nameCollege &&
        !this.formCollege.nameAdmin &&
        !this.formCollege.lastNameAdmin &&
        !this.formCollege.emailAdmin &&
        !this.formCollege.passwordAdmin &&
        !this.formCollege.confirmPassword &&
        !this.formCollege.numberLicences &&
        !this.formCollege.address
      ) {
        this.$router.push('/es/sa/panel/colleges')
      }
      this.CancelCollege.modal = true
    },
    cancelCollegeEvt(confirm) {
      if (confirm) {
        this.$router.push('/es/sa/panel/colleges')
      }

      this.CancelCollege.modal = false
    },
  },
  computed: {},
  mounted() {
    if (this.filters.type === 'TRIAL') {
      this.formCollege.numberLicences = 0
    } else {
      this.formCollege.numberLicences = null
    }
  },
}
</script>

<style scoped>
.schedule-container {
  background-color: #f5f5f5;
  overflow-y: scroll;
  height: calc(100vh - 192px);
}
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}
.radio-border {
  border: 1px solid;
  border-color: #ccc;
  margin-bottom: 0 !important;
  padding: 1.5rem;
}
.radio-up {
  border-radius: 0.5rem 0.5rem 0px 0px;
}
.radio-down {
  border-radius: 0px 0px 0.5rem 0.5rem;
}
.radio-selected {
  background-color: #faeced;
  border-color: #f44336;
}
::v-deep .v-input__slot {
  min-height: unset;
  height: 35px;
}
::v-deep .v-text-field.v-text-field--solo .v-input__control {
  min-height: 30px;

  padding: 0;
}
.radio--container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  height: 35px;
}

/* .border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
  padding: 0;
} */
.container--btn {
  display: flex;
  justify-content: flex-end;
}
.custom-border {
  border-radius: 0.5rem;
  border-color: #ccc !important;
}
.input-height {
  height: 45px;
  padding: 0;
}
::v-deep .v-input__slot {
  min-height: unset;
  height: 35px;
}
::v-deep .v-text-field.v-text-field--solo .v-input__control {
  min-height: 30px;

  padding: 0;
}
.error-pass {
  color: #f44336;
}
</style>
